import { api } from '@/Data/api';
import ss from '../Session';
import { TopikExamType, TopikResponse, TopikListResponse } from './types';

export type ExamWithStats = TopikExamType & {
    statistics?: {
        total_allocations: number;
        active_allocations: number;
        completed_attempts: number;
        average_score: number;
    };
};

export type AllocateExamResponse = {
    questionnaireid: string;
    examid: string;
    userid: string;
    message: string;
};

/**
 * List TOPIK exams (admin/manager only)
 */
export const listExams = async (params?: {
    limit?: number;
    offset?: number;
}): Promise<{ data: TopikExamType[]; total: number } | null> => {
    try {
        const res = await api.get<TopikListResponse<TopikExamType>>('/topik/exam', {
            params,
            headers: { Authorization: `Bearer ${ss.getCurrentSession().jwt}` }
        });
        return res.data?.code === 200
            ? { data: res.data.data ?? [], total: res.data.total ?? 0 }
            : null;
    } catch (e) {
        console.error('Failed to list exams:', e);
        return null;
    }
};

/**
 * Get TOPIK exam details with statistics (admin/manager only)
 */
export const getExam = async (params: {
    examid: string;
}): Promise<ExamWithStats | null> => {
    try {
        const res = await api.get<TopikResponse<ExamWithStats>>('/topik/exam', {
            params,
            headers: { Authorization: `Bearer ${ss.getCurrentSession().jwt}` }
        });
        return res.data?.code === 200 ? (res.data.data ?? null) : null;
    } catch (e) {
        console.error('Failed to get exam:', e);
        return null;
    }
};

/**
 * Allocate TOPIK exam to a user (creates questionnaire)
 */
export const allocateExam = async (params: {
    examid: string;
    userid?: string;
    addressid?: string;
}): Promise<AllocateExamResponse | null> => {
    try {
        const res = await api.post<TopikResponse<AllocateExamResponse>>('/topik/questionnaire', params, {
            headers: { Authorization: `Bearer ${ss.getCurrentSession().jwt}` }
        });
        return res.data?.code === 200 ? (res.data.data ?? null) : null;
    } catch (e) {
        console.error('Failed to allocate exam:', e);
        return null;
    }
};
